import { getLocale } from 'services/LocalizationService';
/**
 * Profile constants
 *
 */
export const DEFAULT_PROFILE_PIC = 'default';
export const DEFAULT_LOCALE = CBS.Registry.region.property?.toLowerCase() ?? '';
export const SECTION_HEADER_CREATE_PIN = getLocale('create_4_digit_pin_kids_profile');
export const SECTION_SUB_HEADER_CREATE_PIN = getLocale('pin_required_to_switch_profiles');
export const DISCLAIMER_URL =
    'https://help.paramountplus.com/s/article/PD-How-do-I-set-parental-controls-for-Paramount';
export const DISCLAIMER_INTL_URL =
    'https://support.paramountplus.com/s/article/PI-How-do-I-set-up-parental-controls';

export const KIDS = 'KIDS';
export const ADULT = 'ADULT';
export const YOUNGER_KIDS = 'YOUNGER_KIDS';
export const ALL = 'ALL';
export const DEFAULT_KIDS_BUTTON_IMAGE =
    'https://wwwimage-intl.pplusstatic.com/thumbnails/photos/w400-q80/asset/12/d9d1ce9b10192978_avatar-family-kids0.75x.png';
export const KID = 'Kid';

export const ALLOWED_PROFILE_TYPES = [KIDS, ADULT, YOUNGER_KIDS];
